import React from 'react'
import Navbar from '../../../../components/Navbar/Navbar'
import Banner from '../../../../components/body/topLocationsComponents/locationsComponents/Banner'

import LocationComponentsCard from '../../../../components/body/topLocationsComponents/locationsComponents/LocationComponentsCard '
import Main_Footer from '../../../../components/footer/IndiaFooter/Main_Footer'
import { allProjectData } from '../../../../data/all_properties/data'
import { filterPropertiesByLocation } from '../../../../components/body/topDevelopersComponents/filterproperty'
import DevelopersPageComponent from '../../../../components/body/topDevelopersComponents/developerspageComponent/developersPageComponent'
import Banner_Trending_Project from '../../../../components/body/Trending-Projects/Banner_Trending_Project'
import { BannerData } from './data'

const DwarkaExpressway = () => {
  const groupedProperties=filterPropertiesByLocation(allProjectData,"Dwarka Expressway");
  return (
    <div>
      <Navbar />
      <Banner_Trending_Project  Bannerdata={BannerData}/>
      {/* Render properties based on grouping condition */}
      <div className="">
        {Object.entries(groupedProperties).length > 0 ? (
          Object.entries(groupedProperties).map(([key, properties]) => (
            <div key={key}>
           
              {/* Render DevelopersPageComponent with filtered data */}
              <DevelopersPageComponent
                developersData={properties}
                 heading={`Properties in ${properties[0]?.projectlocation || 'N/A'}`}
              />
            </div>
          ))
        ) : (
          <p>No properties available.</p> // Fallback message if no properties are found
        )}
      </div>

      <Main_Footer />
    </div>
  );
}

export default DwarkaExpressway